import { Component, OnInit, SecurityContext } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { PopupService } from '../../../shared/modal/popup.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ParamContext } from '../../../shared/service/param.context';
import { GermplasmDetailsContext } from '../../germplasm-details.context';
import { GermplasmDetailsPopupService } from '../../germplasm-details-popup.service';
import { UrlService } from '../../../shared/service/url.service';

@Component({
    selector: 'jhi-germplasm-progenitors-audit-modal',
    templateUrl: './germplasm-progenitors-audit-modal.component.html',
})
export class GermplasmProgenitorsAuditModalComponent implements OnInit {

    gid: number;

    readonly url: SafeResourceUrl;

    constructor(private route: ActivatedRoute,
                private sanitizer: DomSanitizer,
                private activeModal: NgbActiveModal,
                private context: ParamContext,
                private germplasmDetailsContext: GermplasmDetailsContext,
                private urlService: UrlService
    ) {
        const url = '/ibpworkbench/controller/jhipster#/germplasm/progenitors/audit?restartApplication&modal' +
        '&cropName=' + context.cropName +
        '&programUUID=' + context.programUUID +
        '&gid=' + this.germplasmDetailsContext.gid;
        const safeUrl = this.urlService.buildSafeUrl(url);
        // Fall back to a blank page if the URL is not on the allowlist.
        this.url = safeUrl !== null
            ? this.sanitizer.bypassSecurityTrustResourceUrl(safeUrl)
            : this.sanitizer.bypassSecurityTrustResourceUrl('about:blank');
    }

    ngOnInit() {
        (<any>window).closeModal = () => {
            this.activeModal.close();
        };
    }

    dismiss() {
        this.activeModal.dismiss('cancel');
    }
}

@Component({
    selector: 'jhi-germplasm-progenitors-popup',
    template: ''
})
export class GermplasmBasicDetailsAuditPopupComponent implements OnInit {

    constructor(private popupService: PopupService,
                private germplasmDetailsContext: GermplasmDetailsContext,
                private germplasmDetailsPopupService: GermplasmDetailsPopupService,
                private route: ActivatedRoute) {
    }

    ngOnInit(): void {
        const gid = Number(this.route.snapshot.paramMap.get('gid'));

        if (this.germplasmDetailsContext.openedFromWorkbench) {
            this.germplasmDetailsPopupService.close();
        }
        const modal = this.popupService.open(GermplasmProgenitorsAuditModalComponent as Component, { modalDialogClass: 'modal-lg', backdrop: 'static' });
        modal.then((modalRef) => {

            if (this.germplasmDetailsContext.openedFromWorkbench) {
                modalRef.result.then((result) => {
                    this.germplasmDetailsPopupService.open(gid, 'pedigree');
                }, () => {
                    this.germplasmDetailsPopupService.open(gid, 'pedigree');
                });
            }
        });
    }

}
